import { FetchError } from "ofetch"

export const useTrainingRestrictions = () => {
  const { session } = useAuth()

  const videosRestricted = computed(
    () => session.value?.training_restrictions?.videos_remaining === 0,
  )

  const coursesRestricted = computed(
    () => session.value?.training_restrictions?.courses_remaining === 0,
  )

  const quizRestricted = computed(() => {
    const remaining =
      session.value?.training_restrictions?.phishing_quiz_questions_remaining

    if (remaining == null) {
      return false
    }

    return remaining < 5
  })

  function isTrainingRestrictionLimitExceededError(error: unknown) {
    return (
      error instanceof FetchError &&
      error.data?.message == "api.messages.limit_exceeded"
    )
  }

  return {
    videosRestricted,
    coursesRestricted,
    quizRestricted,
    isTrainingRestrictionLimitExceededError,
  }
}
